export const CHART_COLOR_VARS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
] as const;

// High-contrast categorical palette for dense multi-series analytics charts.
// Keep this larger than the expected visible program count so a single chart
// does not repeat near-identical gold/orange/teal shades across adjacent series.
const DISTINCT_CHART_COLORS = [
  '#2563eb', // blue
  '#dc2626', // red
  '#059669', // green
  '#7c3aed', // violet
  '#d97706', // amber
  '#0891b2', // cyan
  '#db2777', // magenta
  '#65a30d', // lime
  '#ea580c', // orange
  '#4f46e5', // indigo
  '#0f766e', // teal
  '#9333ea', // purple
  '#be123c', // rose
  '#0369a1', // sky
  '#854d0e', // ochre
  '#15803d', // forest
] as const;

export const COLOR_PRIMARY = 'hsl(var(--primary))';
export const COLOR_MUTED = 'hsl(var(--muted-foreground))';
export const COLOR_POSITIVE = 'hsl(var(--positive-foreground))';
export const COLOR_ATTENTION = 'hsl(var(--attention-foreground))';
export const COLOR_CRITICAL = 'hsl(var(--critical-foreground))';

export const colorForSeriesIndex = (index: number): string =>
  DISTINCT_CHART_COLORS[index % DISTINCT_CHART_COLORS.length];
